import { getPerformance, trace, PerformanceTrace } from 'firebase/performance'
import { InternalAxiosRequestConfig } from 'axios'
import { FirebaseInstance } from './instance'
import { User } from 'types/user'

FirebaseInstance.initialize()

export class FirebasePerformance {
  activeTraces: Map<any, PerformanceTrace>
  perf = getPerformance()

  constructor() {
    this.activeTraces = new Map()
  }

  public startTrace(config: InternalAxiosRequestConfig, options: { user?: User }) {
    const { user } = options
    const url = config?.url ?? ''
    const method = config?.method ?? 'GET'

    const traceName = `api_call_${config.method}_${url}`
    const requestTrace = trace(this.perf, traceName)
    requestTrace.start()

    // Aggiungi attributi utili
    requestTrace.putAttribute('method', method)
    requestTrace.putAttribute('url', url)
    user?._id && requestTrace.putAttribute('user_id', user._id)

    this.activeTraces.set(config, requestTrace)
    return requestTrace
  }

  stopTrace(config: any, response: any) {
    const trace = this.activeTraces.get(config)
    if (trace) {
      // Aggiungi metriche sulla risposta
      trace.putMetric('status_code', response?.status || 0)
      trace.putMetric('response_size', JSON.stringify(response?.data).length || 0)

      if (response?.headers?.['x-response-time']) {
        trace.putMetric('server_time_ms', parseInt(response.headers['x-response-time']))
      }

      trace.stop()
      this.activeTraces.delete(config)
    }
  }
}
